<span class="odds-fav-icon fav-match" [ngClass]="{ 'fav-match': isOnMatch }">
    <svg class="fav-icon-svg" data-crlat="favouriteIcon" [ngClass]="{ active: isActive }">
        <use xlink:href="#star"></use>
    </svg>
</span>
